// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCxOYWmvvgkdCazn1Zf-i6dc8i_gBXLWRE",
  authDomain: "magikmat-79a31.firebaseapp.com",
  projectId: "magikmat-79a31",
  storageBucket: "magikmat-79a31.appspot.com",
  messagingSenderId: "481330856007",
  appId: "1:481330856007:web:0cb0d130f2b00f40cfb162",
  measurementId: "G-RL3XF40YWV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);